/* eslint-disable */
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card, Grid
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useFormik, Form, FormikProvider } from 'formik';
import {
    Stack, TextField, CardContent, Button, Typography, Box
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { ToastContainer, toast } from 'react-toastify';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import token from '../../../../helpers/TokenDecoder';
import { AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Services';;
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorCancel: {
        backgroundColor: "red",
    },
    colorRecord: {
        backgroundColor: "green",
    },
    bold: {
        fontWeight: 600,
    }

}));

export default function OperationEntityAddEdit() {
    const classes = useStyles();
    const screenCode = 'OPERATIONENTITY';
    const navigate = useNavigate();
    const [isButtonEnable, setIsButtonEnable] = useState(false);
    const [groupList, setGroupList] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    const [productDetails, setProductDetails] = useState([]);
    const [productList, setProductList] = useState([]);
    const [checked, setChecked] = useState([]);
    const [LeftNewArray, setLeftNewArray] = useState([]);
    const [RightNewArray, setRightNewArray] = useState([]);
    const [RightNewArrayAlreadyStoredAccounts, setRightNewArrayAlreadyStoredAccounts] = useState([])
    const [RemovedLedgerAccountList, setRemovedLedgerAccountList] = useState([]);
    const [specialProductcatogery, setSpecialProductcatogery] = useState([]);
    const leftChecked = intersection(checked, LeftNewArray);
    const rightChecked = intersection(checked, RightNewArray);

    function not(a, b) {
        return a.filter((value) => b.map(obj => obj.productID).indexOf(value.productID) === -1);
    }

    function intersection(a, b) {
        return a.filter((value) => b.map(obj => obj.productID).indexOf(value.productID) !== -1);
    }

    const [formData, setFormData] = useState({
        groupID: "0",
        operationEntityCode: "",
        operationEntityName: "",
        operationEntityTypeID: 0,
        productCategoryID: "0",
        specialProductCategoryID: "0",
        isActive: true
    });
    const [tokenData, setTokenData] = useState({
        group: 0,
        factory: 0,
        userID: 0
    });

    const [cropData, setCropData] = useState({
        productCategoryID: '0',
        cropID: '0'
    });

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: false,
        submitButtonName: "Save",
        pageName: "Add Operation Entity"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
    });
    const UserRoleSearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please select a Group').required('Group Required'),
        operationEntityCode: Yup.string().required('Operation Entity Code required').matches(/^(?!000)[0-9]{3}$/, 'Only allow 3 numbers'),
        operationEntityName: Yup.string().required('Operation Entity Name required'),
        operationEntityTypeID: Yup.number().min(1, 'Operation Entity Type required').required('Operation Entity Type required')

    });

    const { operationEntityID } = useParams();
    let decrypted = 0;

    const handleToggle = (value) => () => {
        const currentIndex = checked.map(obj => obj.productID).indexOf(value.productID);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setChecked(newChecked);
    };

    const handleCheckedRight = () => {
        setRemovedLedgerAccountList(RemovedLedgerAccountList.concat(leftChecked))
        setRightNewArray(RightNewArray.concat(leftChecked));
        setLeftNewArray(not(LeftNewArray, leftChecked));
        setChecked(not(checked, leftChecked));
    };

    const handleCheckedLeft = () => {

        setRemovedLedgerAccountList(RemovedLedgerAccountList.concat(rightChecked))
        setLeftNewArray(LeftNewArray.concat(rightChecked));
        setRightNewArray(not(RightNewArray, rightChecked));
        setChecked(not(checked, rightChecked));
    };

    function handleScreenChange(e, data) {
        const newChecked = [...checked];
        if (e.target.checked) {
            let result = [];
            data.forEach(x => {
                const found = newChecked.find(y => y.productID == x.productID)
                if (found) {
                    result.push(found)
                }
                else {
                    result.push(x)
                }
            })
            setChecked(result);
        }
        else {
            let result = [];
            data.forEach(x => {
                const found = newChecked.find(y => y.productID == x.productID)
                if (!found) {
                    result.push(x)
                }
            })
            setChecked(result);
        }
    }

    function checkSelectLength(checked, items) {
        let result = [];
        items.forEach(x => {
            const found = checked.find(y => y.productID == x.productID)
            if (found) {
                result.push(found)
            }
        })
        if (result.length == items.length) {
            return true;
        }
        else {
            return false;
        }
    }

    const customList = (items) => (
        items.length > 0 ?
            <Paper className={classes.paper}>
                <ListItem role="listitem">
                    <ListItemIcon>
                        <Checkbox
                            color="secondary"
                            onClick={(e) => handleScreenChange(e, items)}
                            checked={items.length != 0 && checkSelectLength(checked, items)}
                        />
                    </ListItemIcon>
                    <ListItemText primary={"Select All"} />
                </ListItem>
                <List dense={true} component="div" role="list" sx={{
                    position: 'relative',
                    overflow: 'auto',
                    maxHeight: 300
                }}>

                    {items.map((value) => {
                        const labelId = `transfer-list-item-${value.productID}-label`;
                        return (
                            <ListItem key={value.productID} role="listitem" button onClick={handleToggle(value)}>
                                <ListItemIcon>
                                    <Checkbox
                                        checked={checked.map(obj => obj.productID).indexOf(value.productID) !== -1}
                                        tabIndex={-1}
                                        color='secondary'
                                        disableRipple
                                        inputProps={{ 'aria-labelledby': labelId }}
                                    />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={value.productName} />
                            </ListItem>
                        );
                    })}
                    <ListItem />
                </List>
            </Paper> : null
    );

    useEffect(() => {

        trackPromise(GetAllProductsDetails());

        const decrypted = AESDecryptionParam(operationEntityID);

        if (decrypted && decrypted !== "0") {

            setPageProps({
                ...pageProps,
                isEdit: true,
                submitButtonName: "Update",
                editingID: parseInt(decrypted),
                pageName: "Edit Operation Entity"
            });

            trackPromise(setForEdit(decrypted));
        } else {
            setPageProps({
                ...pageProps,
                isEdit: false,
                submitButtonName: "Add",
                editingID: null,
                pageName: "Add Operation Entity"
            });

            trackPromise(GetAllProductsDetailsByProductSpecialProduct());
        }

        const tok = token.getGroupFactoryToken();
        const userID = token.getUserIDFromToken();
        if (tok) {
            setTokenData({
                group: tok.group,
                factory: tok.factory,
                userID: parseInt(userID)
            });
        }
    }, []);

    // async function GetAllProductsDetailsByProductSpecialProduct() {
    //     const res = await services.GetAllProductsDetailsByProductSpecialProduct(formik.values.productCategoryID, formik.values.specialProductCategoryID);
    //     if (res != null) {
    //         setLeftNewArray(res); // Set unmapped products to product side
    //     }
    // }

    async function GetAllProductsDetailsByProductSpecialProduct() {
        const res = await services.GetAllProductsDetailsByProductSpecialProduct(formik.values.productCategoryID, formik.values.specialProductCategoryID)
        if (res != null) {
            if (RightNewArray.length === 0) {
                res.length === 0 ?
                    setLeftNewArray([]) :
                    setLeftNewArray(res)
            }
            else {
                await SetAndFilterMainLedgerAccountListArrays(res, RightNewArray)
            }
        }
    }

    async function setForEdit(id) {
        ClearAllArrays();
        let result = await services.GetOperationEntityDetailsDetailsByOperationEntityID(id);
        if (result != null) {
            setValues((prevState) => ({
                ...prevState,
                groupID: result[0].groupID,
                operationEntityID: result[0].factoryID,
                operationEntityCode: result[0].operationEntityCode,
                operationEntityName: result[0].operationEntityName,
                operationEntityTypeID: result[0].operationEntityTypeID,
                isActive: result[0].isActive
            }));
            const productList = await services.GetAllProductsDetails();
            if (productList.length === 0) {
                alert.error("Products not found");
            }
            if (result[0].linkedProductList === 0) {
                setRightNewArray([]);
                setRightNewArrayAlreadyStoredAccounts([])
            } else {
                setRightNewArray(result[0].linkedProductList)
                setRightNewArrayAlreadyStoredAccounts(result[0].linkedProductList)
            }
            const inter = await SetAndFilterMainLedgerAccountListArrays(productList, result[0].linkedProductList)
        }
    }

    async function SetAndFilterMainLedgerAccountListArrays(productDetails, linkedAccountList) {
        const filteredAccountList = not(productDetails, linkedAccountList)
        filteredAccountList.length === 0 ?
            setLeftNewArray([]) :
            setLeftNewArray(filteredAccountList);

        return filteredAccountList;
    }

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityCode: formData.operationEntityCode,
            operationEntityName: formData.operationEntityName,
            operationEntityTypeID: formData.operationEntityTypeID,
            productCategoryID: formData.productCategoryID,
            specialProductCategoryID: formData.specialProductCategoryID,
            isActive: formData.isActive
        },

        validationSchema: UserRoleSearchSchema,

        onSubmit: (values) => {
            if (pageProps.isEdit != 0) {
                trackPromise(UpdateOperationEntity(values, tokenData.userID, pageProps.editingID));
            } else {
                trackPromise(SaveOperationEntity(values, tokenData.userID));
            }

        },
    });

    useEffect(() => {
        getPermissions();
    }, [])

    useEffect(() => {
        GetProductDetails(cropData.productCategoryID);
    }, [cropData.productCategoryID]);

    useEffect(() => {
        trackPromise(GetAllProductsDetailsByProductSpecialProduct());
        if (formik.values.productCategoryID > "0") {
            setValues({
                ...values,
                specialProductCategoryID: "0",
            })
        }
    }, [formik.values.productCategoryID]);

    useEffect(() => {
        trackPromise(GetAllProductsDetailsByProductSpecialProduct());
        if (formik.values.specialProductCategoryID > "0") {
            setValues({
                ...values,
                productCategoryID: "0",
            })
        }
    }, [formik.values.specialProductCategoryID]);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWOPERATIONENTITY');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });
        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        })
        GetAllGroups();
        GetProductCategoties();
        trackPromise(GetSpecialProductCategoties());
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetProductCategoties() {
        var res = await services.GetProductCategoties()
        if (res != null) {
            setProductcatogery(res);
        }
    }
    async function GetSpecialProductCategoties() {
        var res = await services.GetSpecialProductCategotiesForDropDown()
        if (res != null) {
            setSpecialProductcatogery(res);
        }
    }

    async function GetAllProductsDetails() {
        var res = await services.GetAllProductsDetails()
        if (res != null) {
            setProductDetails(res);
        }
    }

    async function GetAllProductsDetailsByProductSpecialProduct() {
        var res = await services.GetAllProductsDetailsByProductSpecialProduct(formik.values.productCategoryID, formik.values.specialProductCategoryID)
        if (res != null) {
            if (RightNewArray.length === 0) {
                res.length === 0 ?
                    setLeftNewArray([]) :
                    setLeftNewArray(res)
            }
            else {
                await SetAndFilterMainLedgerAccountListArrays(res, RightNewArray)
            }
        }
    }

    async function GetProductDetails(ProductCategoryID) {
        var res = await services.GetProductDetails(ProductCategoryID);
        if (res != null) {
            setProductList(res);
        }
    }

    async function GetProductDetails(ProductCategoryID) {
        var res = await services.GetProductDetails(ProductCategoryID);
        if (res != null) {
            setProductList(res);
        }
    }

    async function SaveOperationEntity(values, user) {
        let requestModel = {
            groupID: parseInt(values.groupID),
            operationEntityCode: values.operationEntityCode,
            operationEntityName: values.operationEntityName,
            factoryType: values.operationEntityTypeID,
            isActive: values.isActive,
            createdBy: parseInt(user),
            linkedProductList: not(RightNewArray, RightNewArrayAlreadyStoredAccounts),
        }

        var res = await services.SaveUserRole(requestModel);
        if (res.statusCode === "Success") {
            ClearAllArrays();
            toast.success(res.message);
            navigate('/dashboard/operationEntity');
            setIsButtonEnable(true);
        } else {
            toast.error(res.message);
        }
    }

    async function UpdateOperationEntity(values, user, operationEntityID) {
        let requestModel = {
            groupID: parseInt(values.groupID),
            factoryID: parseInt(operationEntityID),
            operationEntityCode: values.operationEntityCode,
            operationEntityName: values.operationEntityName,
            factoryType: values.operationEntityTypeID,
            isActive: values.isActive,
            createdBy: parseInt(user),
            linkedProductList: not(RightNewArray, RightNewArrayAlreadyStoredAccounts),
            removedLinkedAccountList: RemovedLedgerAccountList
        }
        var res = await services.EditUserRole(requestModel);
        if (res.statusCode === "Success") {
            toast.success(res.message);
            navigate('/dashboard/operationEntity');
            setIsButtonEnable(true);
        } else {
            toast.error(res.message);
        }
    }

    function ClearAllArrays() {
        setChecked([])
        setLeftNewArray([])
        setRightNewArray([])
        setRightNewArrayAlreadyStoredAccounts([])
        setRemovedLedgerAccountList([])
    }

    function generateProductCategoryDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(x.isActive == true ? <MenuItem key={x.productCategoryID} value={x.productCategoryID}>{x.productCategoryName}</MenuItem> : null)
            });
        }
        return items
    }

    function generateSpecialProductCategoryDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(x.isActive == true ? <MenuItem key={x.specialProductCategoryID} value={x.specialProductCategoryID}>{x.specialProductCategoryName}</MenuItem> : null)
            });
        }
        return items
    }

    function clearAll() {
        setValues({
            ...values,
            operationEntityCode: "",
            operationEntityName: ""
        })
    }

    const { errors, touched, setValues, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    return (
        <>
            <LoadingComponent />
            <Page title="Operation Entity |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/operationEntity"}
                        btname="Back"
                        pageName={pageProps.pageName}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Operation Entity Type *"
                                        value={formik.values.operationEntityTypeID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityTypeID')}
                                        error={Boolean(touched.operationEntityTypeID && errors.operationEntityTypeID)}
                                        helperText={touched.operationEntityTypeID && errors.operationEntityTypeID}
                                    >
                                        <MenuItem key={0} value={0}>Select Operation Entity Type</MenuItem>
                                        <MenuItem value={1}>FDC</MenuItem>
                                        <MenuItem value={2}>FCC</MenuItem>
                                        <MenuItem value={4}>Head Office</MenuItem>
                                        <MenuItem value={5}>Finance</MenuItem>

                                    </TextField>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Operation Entity Code *"
                                        value={formik.values.operationEntityCode}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityCode')}
                                        error={Boolean(touched.operationEntityCode && errors.operationEntityCode)}
                                        helperText={touched.operationEntityCode && errors.operationEntityCode}
                                    />
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Operation Entity Name *"
                                        value={formik.values.operationEntityName}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityName')}
                                        error={Boolean(touched.operationEntityName && errors.operationEntityName)}
                                        helperText={touched.operationEntityName && errors.operationEntityName}
                                    />
                                </Stack>

                                <Card>
                                    <CardContent>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Product Category"
                                                value={formik.values.productCategoryID}
                                                style={{ width: '300px' }}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('productCategoryID')}
                                                error={Boolean(touched.productCategoryID && errors.productCategoryID)}
                                                helperText={touched.productCategoryID && errors.productCategoryID}
                                            >
                                                <MenuItem key={0} value={0}> Select Product Category</MenuItem>
                                                {generateProductCategoryDropDownMenu(productcatogery)}
                                            </TextField>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Special Product Category"
                                                value={formik.values.specialProductCategoryID}
                                                style={{ width: '300px' }}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('specialProductCategoryID')}
                                                error={Boolean(touched.specialProductCategoryID && errors.specialProductCategoryID)}
                                                helperText={touched.specialProductCategoryID && errors.specialProductCategoryID}
                                            >
                                                <MenuItem key={0} value={0}> Select Special Product Category</MenuItem>
                                                {generateSpecialProductCategoryDropDownMenu(specialProductcatogery)}
                                            </TextField>
                                        </Stack>
                                        <Box marginTop={4} />
                                        {
                                            RightNewArray.length > 0 || LeftNewArray.length > 0 ?
                                                <Grid container spacing={3}>
                                                    <Grid item md={5} xs={12} >
                                                        <Typography variant='h5'>Products</Typography> <br />
                                                        {customList(LeftNewArray)}
                                                    </Grid>
                                                    <Grid item md={2} xs={12}>
                                                        <Grid container direction="column" alignItems="center" style={{ marginTop: "30%" }}>
                                                            <Button
                                                                variant="outlined"
                                                                size="small"
                                                                color='secondary'
                                                                className={classes.button}
                                                                onClick={handleCheckedRight}
                                                                disabled={leftChecked.length === 0}
                                                                aria-label="move selected right"
                                                            >
                                                                &gt;
                                                            </Button>
                                                            <Button
                                                                variant="outlined"
                                                                size="small"
                                                                color='secondary'
                                                                className={classes.button}
                                                                onClick={handleCheckedLeft}
                                                                disabled={rightChecked.length === 0}
                                                                aria-label="move selected left"
                                                            >
                                                                &lt;
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item md={5} xs={12}>
                                                        <Typography variant='h5'>Mapped Products</Typography> <br />
                                                        {customList(RightNewArray)}
                                                    </Grid>
                                                </Grid>
                                                : null}
                                    </CardContent>
                                </Card>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                value={formik.values.isActive}
                                                checked={formik.values.isActive}
                                                {...getFieldProps('isActive')}
                                                onClick={formik.handleChange}
                                                color='error'
                                                name="isActive"
                                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                            />}
                                        label="Is Active"
                                    />
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        color='error'
                                        onClick={() => clearAll()}
                                    > Clear</Button>
                                    <Button
                                        disabled={isButtonEnable}
                                        type="submit"
                                        variant="contained"
                                        color='secondary'
                                    >{pageProps.submitButtonName}</Button>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                </Container>
            </Page>
        </>
    );
}